import template from './shared-project-view.html';
import controller from './shared-project-view.controller';

let sharedProjectViewComponent = {
  restrict: 'E',
  bindings: {
    project: '<',
    fundingMode: '@?'
  },
  template,
  controller
};

export default sharedProjectViewComponent;



// WEBPACK FOOTER //
// ./client/pages/admin/project-details/views/shared-project-view/shared-project-view.component.js